import {message} from '@sail/intl';
import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

const messages = {
  errorText: message({
    id: 'connectEmbed.payouts.errorBoundary.text',
    defaultMessage:
      'Your money is secure, but your payouts information cannot be loaded here.',
    description: 'Message shown when an unhandled payouts error is caught',
  }),
};

const SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE =
  'show-manual-payout-schedule-contact-platform-message' as const;
const HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE =
  'hide-manual-payout-schedule-status' as const;

export type PayoutsComponentHtmlParams = Partial<Record<string, string>>;

export const PayoutsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "payoutsExperience" */ '../../../components/Payouts/PayoutsV2/PayoutsV2'
    ),
  messageOverrides: messages,
  releaseState: 'ga',
  isVisibleInMobileSdk: true,
  enabledOverrideFlag: ComponentOverrideFlag.payouts,
  htmlAttributes: {
    [SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE]: {
      isInternal: true,
    },
    [HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setShowManualPayoutScheduleContactPlatformMessage: {
      type: 'AttributeSettingMethod',
      attribute: SHOW_MANUAL_PAYOUT_SCHEDULE_CONTACT_PLATFORM_MESSAGE_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets the show-manual-payout-schedule-contact-platform-message attribute to control whether the payouts component renders a message about contacting the platform for manual payout schedule.',
    },
    setHideManualPayoutScheduleStatus: {
      type: 'AttributeSettingMethod',
      attribute: HIDE_MANUAL_PAYOUT_SCHEDULE_STATUS_ATTRIBUTE,
      isInternal: true,
      description:
        'Sets the hide-manual-payout-schedule-status attribute to control whether the "Next payout Manual" status is hidden in the payouts component.',
    },
  },
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Displays the list of payouts, allows for manual payouts, instant payouts, and management of payout schedule.',
  friendlyName: 'Payouts',
  docSitePath: '/connect/supported-embedded-components/payouts',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-payouts-iframe',
    rcTestUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/sus-payouts-iframe-rc',
  },
  enableV2APIToken: true,
};
